import { Directive, ElementRef, Input, HostListener, Renderer2 } from '@angular/core';
import { appVariables } from '../constants/Common.constant';

@Directive({
  selector: '[restrictMaliciousInput]'
})
export class RestrictMaliciousInputDirective {
  //@Input('inputrestriction') InputRestriction : string;

  private element : ElementRef;

  constructor(element : ElementRef,private renderer: Renderer2) {
    this.element = element;
  }

  @HostListener('blur', ['$event'])
  handleKeyPress(event)
  {
    const errorSpan = this.element.nativeElement.nextElementSibling;
    if (errorSpan && errorSpan.classList.contains('alert-text')) {
        errorSpan.remove();
    }
    var regex = new RegExp(/<\/?[^>]+(>|$)/g);
    var str = event.target.value;
    if (regex.test(str)
      || appVariables.RegexXSSPattern.test(str)
      || str.toLowerCase().includes('script')
      || str.toLowerCase().includes('cookie')
      || str.toLowerCase().includes('document')
      || str.toLowerCase().includes('document.createelement')
      || str.toLowerCase().includes('document.ready')
      || str.toLowerCase().includes('document.cookie')
      || str.toLowerCase().includes('document.body')
      || str.toLowerCase().includes('document.body.append')
      || str.toLowerCase().includes('src')
      || str.toLowerCase().includes('iframe')
      || str.toLowerCase().includes('onload')
      || str.toLowerCase().includes('onerror')
      || str.toLowerCase().includes('onmouseover')
      || str.toLowerCase().includes('onclick')
      || str.toLowerCase().includes('error')
      || str.toLowerCase().includes('javascript:alert(0)')
      || str.toLowerCase().includes('javascript:alert')
      || str.toLowerCase().includes('http')
      || str.toLowerCase().includes('https')
      || str.toLowerCase().includes('//')
      || str.toLowerCase().includes('://')
      || str.toLowerCase().includes('alert')
      || str.toLowerCase().includes('http-equiv')
      || str.toLowerCase().includes('request.getparameter')
      || str.toLowerCase().includes('$_server')
      || str.toLowerCase().includes('request_uri')
      || str.toLowerCase().includes('xmlhttprequest')
      || str.toLowerCase().includes('window.location')
      || str.toLowerCase().includes('executequery')) {
      const target = this.element.nativeElement;
      target.value = '';
      var evt = document.createEvent("HTMLEvents");
      evt.initEvent("input", false, true);
      this.element.nativeElement.dispatchEvent(evt);
      let h = document.createElement("span");
      h.className += "alert-text";
      let label = (this.element.nativeElement.placeholder) ? this.element.nativeElement.placeholder.replace(/\*/g,'') : `input`;
      let t = document.createTextNode(`Please enter valid ${label}`);
      h.appendChild(t)
      this.element.nativeElement.after(h);
      return true;
    }
      event.preventDefault();
      return false;
   
  }

}



// WEBPACK FOOTER //
// ./src/app/core/directives/restrictMaliciousInput.directive.ts